import { useEffect, useState } from 'react';
import { ShuttleService } from '../../../services/shuttle';
import { ShuttleLocation } from '../../../domain/shuttle';

export const useShuttleLocations = () => {
  const [shuttleLocations, setShuttleLocations] = useState<ShuttleLocation[]>([]);

  const fetchShuttleLocations = async () => {
    try {
      const service = new ShuttleService();
      const locations = await service.getShuttleLocations();

      const shuttleLocationsAsArray = Object.keys(locations).map((key) => ({
        label: key,
        value: locations[key],
      }));

      setShuttleLocations(shuttleLocationsAsArray);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchShuttleLocations();
  }, []);

  return { shuttleLocations };
};
